// Default theme colors (fallback) - matches _variables.scss
const DEFAULT_COLORS = {
    textColor: '#71717A',
    globalBackgroundColor: '#f9f9fc',

    primary: '#1C5888',
    primaryLight1: '#1C5888',
    primaryLight2: '#B1DCF3',
    primaryDark1: '#014766',
    primaryDark2: '#014B6B',
    secondary: '#70AED1',
    secondaryLight: '#C7E1EF',
    secondaryDark: '#94BDD3',
    white: '#FFFFFF',
    black: '#000000',
    whiteDark: '#F8F8F8',
    gray: '#403F3F',
    darkGray: '#4F4F4F',
    lightGray: '#D9D9D9',
    mediumGray: '#828282',
    red: '#F80F1B',
    lightRed: '#FFE2E1',
    darkRed: '#830000',
    green: '#05A14B',
    lightGreen: '#E4F2EA',
    orangeYellow: '#FFC000',
    orangeDark: '#F9A42A',
    iceBlue: '#FFFFFF',
    iceBlue2: '#F5F6F9',
    iceBlue3: '#D8F1FF',
    iceBlue4: '#7ED0FD'
};

const DEFAULT_TYPOGRAPHY = {
    fontFamily: {
        primary: 'Poppins, sans-serif'
    }
};

const DEFAULT_COMPONENTS_STYLE = {
    mobileAppSuggestion: {
        color: '#1E1F41',
        backgroundColor: '#FFFFFF',
    },

    report: {
        textColor: '#71717A',
        globalBackgroundColor: '#f9f9fc',
        iceBlue4: '#7ED0FD',

        // Standard Medical Theme Colors
        standardBlue: '#1176B4',
        standardBlueDark: '#0D5A8A',
        standardBlueLight: '#E7F3F8',

        // Universal Status Colors
        statusAbnormal: '#ed6b75',     // ROMColor -1
        statusNormal: '#27AE60',       // ROMColor 0
        statusWarning: '#20B2AA',      // ROMColor 1
        statusWithin: '#27AE60',       // ROMColor 2 (within range)
        statusBelow: '#F39C12',        // Orange (legacy)
        statusAbove: '#3498DB',        // Blue (legacy)

        // UI Foundation Colors
        textPrimary: '#2C3E50',
        textSecondary: '#7F8C8D',
        borderColor: '#E0E0E0',
        bgLight: '#F8F9FA'
    },

    // ============================================================================
    // TAB MENU COMPONENT (9 properties)
    // Styles for tab navigation menus across the application
    // ============================================================================
    tabMenu: {
        activeColor: '#71717A',
        activeBackgroundColor: '#f0f0f0',
        hoverBackgroundColor: '#F4F4F5',
        color: '#71717A',
        backgroundColor: '#FFFFFF',
        hoverColor: '#71717A',
        borderColor: '',
        activeBorderColor: '',
        hoverBorderColor: '',
    },

    customModal: {
      backgroundColor: '#FFFFFF',
      headerBackgroundColor: '#FFFFFF',
    },

    paymentModal: {
      backgroundColor: '#FFFFFF',

      successBackgroundColor: '#FFFFFF',
      successColor: '#000000',

      failedBackgroundColor: '#FFFFFF',
      failedColor: '#000000',
    },

    signinSignup: {
        header: {
            color: "#FFFFFF"
        },

        input: {
            borderColor: '#F4F4F5',
            color: '#F4F4F5',
            placeholderColor: '#F4F4F5',
        },

        submitButton: {
            backgroundColor: '#1C5888',
            color: '#FFFFFF',
        },
        linkText: {
            color: '#36A4F6'
        }
    },

    // ============================================================================
    // MAIN HEADER WRAPPER COMPONENT (51 properties)
    // Comprehensive styling for the main application header
    // Sections: dropdown, navItemActive, userProfile, badge, logoutButton,
    //           movementToggleButton, backToMyBackHubButton, mobileToggle
    // ============================================================================
    mainHeaderWrapper: {
        backgroundColor: '#FFFFFF',

        signUpLink: {
            backgroundColor: '#FFFFFF',
            color: '#4F4F4F',
        },

        languageDropdown: {
            backgroundColor: '#F4F4F5',
            color: '#4F4F4F',
        },

        userDropdown: {
            backgroundColor: '#F4F4F5',
            color: '#4F4F4F',
        },

        // --- Dropdown Menu (5 properties) ---
        dropdown: {
            backgroundColor: '#F4F4F5',
            color: '#4F4F4F',
            borderColor: '#FFFFFF',
            hoverBackgroundColor: '#F4F4F5',
            hoverColor: '#4F4F4F',
        },

        // --- Active Navigation Item (2 properties) ---
        navItemActive: {
            backgroundColor: '#F4F4F5',
            color: '#D8F1FF',
        },

        // --- User Profile Section (3 properties) ---
        userProfile: {
            borderColor: '#09090B',
            nameColor: '#09090B',
            deleteTextColor: '#09090B',
        },

        // --- Badge (2 properties) ---
        badge: {
            backgroundColor: '#F4F4F5',
            color: '#D8F1FF',
        },

        // --- Logout Button (4 properties) ---
        logoutButton: {
            backgroundColor: '#F4F4F5',
            color: '#09090B',
            hoverBackgroundColor: '#F4F4F5',
            hoverColor: '#09090B',
        },

        // --- Movement Toggle Button (2 properties) ---
        movementToggleButton: {
            backgroundColor: '#F4F4F5',
            color: '#09090B',
        },

        // --- Back to MyBackHub Button (5 properties) ---
        backToMyBackHubButton: {
            color: '#09090B',
            borderColor: '#F4F4F5',
            hoverBackgroundColor: '#F4F4F5',
            hoverColor: '#D8F1FF',
            mobileColor: '#014766',
        },

        // --- Mobile Toggle (1 property) ---
        mobileToggle: {
            iconColor: '#09090B',
        },
    },

    // ============================================================================
    // SELECT OPTION COMPONENT (1 property)
    // Styling for select/dropdown input elements
    // ============================================================================
    selectOption: {
        borderColor: '#F4F4F5',
        backgroundColor: '#F4F4F5',
    },

    // ============================================================================
    // NEW ASSESSMENT INVITATION COMPONENT (15 properties)
    // Styles for assessment invitation cards and buttons
    // Sections: button, dashboardItemSpepbarContainer
    // ============================================================================
    newAssessmentInvitation: {
        backgroundColor: '#ffffff',
        color: '#1C5888',

        // --- Button Section (4 properties) ---
        button: {
            color: '#FFFFFF',
            backgroundColor: '#1C5888',
            hoverBackgroundColor: '#f4f4f4',
            hoverColor: '#FFFFFF'
        },

        // --- Dashboard Item Separator (1 property) ---
        dashboardItemSpepbarContainer: {
            borderColor: '#f4f4f4',
        },

        // --- Table Section (4 properties) ---
        table: {
            header: {
                color: '#4F4F4F',
                backgroundColor: '#f4f4f4',
                borderRightColor: '#f4f4f4',
                borderBottomColor: '#f4f4f4',
            }
        }
    },

    // ============================================================================
    // MMH TABLE COMPONENT (17 properties)
    // My Mental Health table button styles
    // Sections: outlinedButton, solidButton
    // ============================================================================
    mmhTable: {
        header: {
            backgroundColor: '#F4F4F5',
        },

        // --- Outlined Button (5 properties) ---
        outlinedButton: {
            color: '#ffffff',
            backgroundColor: '',
            hoverBackgroundColor: '',
            hoverColor: '#1C5888',
            borderColor: '#F4F4F5'
        },

        // --- Solid Button (5 properties) ---
        solidButton: {
            color: '#ffffff',
            selectedBackgroundColor: '#1C5888',
            selectedBorderColor: '#1C5888',
            backgroundColor: '#1C5888',
            hoverBackgroundColor: '#1C5888',
            hoverColor: '#ffffff',
            borderColor: ''
        },
        checkboxButtonBorderColor: {
            color: '#3BA7E2',
        },

        mmhTableCheckboxButton: {
            color: '#FFFFFF',
            backgroundColor: '#3BA7E2',
        }
    },

    // ============================================================================
    // MY ASSESSMENTS DETAIL COMPONENT (87 properties)
    // Comprehensive styling for assessment detail pages and tables
    // Sections: filter, badge, primaryButton, successButton, dangerButton,
    //           spinner, container, emptyState, table
    // Table subsections: header, body, loader, pagination
    // ============================================================================
    myAssessmentsDetail: {
        color: '#434167',
        backgroundColor: '#FFFFFF',

        // --- Filter Section (5 properties) ---
        filter: {
            borderColor: '#1C5888',
            borderColorFocus: '#D8F1FF',
            backgroundColor: '#ffffff',
            placeholderColor: '#1C5888',
            labelColor: '#1C5888',
        },

        // --- Badge Section (2 properties) ---
        badge: {
            warningBackgroundColor: '#ffefc5',
            warningTextColor: '#000000',
        },

        // --- Primary Button (4 properties) ---
        primaryButton: {
            backgroundColor: '#1C5888',
            color: '#ffffff',
            hoverBackgroundColor: '#0e5f91',
            hoverColor: '#ffffff',
        },

        // --- Success Button (4 properties) ---
        successButton: {
            backgroundColor: '#28a745',
            color: '#ffffff',
            hoverBackgroundColor: '#218838',
            hoverColor: '#ffffff',
        },

        // --- Danger Button (4 properties) ---
        dangerButton: {
            backgroundColor: '#dc3545',
            color: '#ffffff',
            hoverBackgroundColor: '#c82333',
            hoverColor: '#ffffff',
        },

        // --- Spinner Section (2 properties) ---
        spinner: {
            borderColor: 'rgba(0,0,0,0.06)',
            accentColor: '#1C5888',
        },

        // --- Container Section (2 properties) ---
        container: {
            backgroundColor: '#ffffff',
            borderColor: '#e0e0e0',
        },

        // --- Empty State (2 properties) ---
        emptyState: {
            textColor: '#4C4C4C',
            fontSize: '1.3rem',
        },

        // --- Table Section (30 properties total) ---
        table: {
            // Table Header (4 properties)
            header: {
                color: '#71717A',
                backgroundColor: '#FFFFFF',
                borderRightColor: '#FFFFFF',
                borderBottomColor: '#FFFFFF',
            },

            // Table Body (3 properties)
            body: {
                row: {
                    borderBottomColor: '#FFFFFF',
                    nthChild2n: {
                        backgroundColor: '#FFFFFF',
                    },
                }
            },

            // Table Loader (5 properties)
            loader: {
                color: '#4f4f4f',
                backgroundColor: '#f4f4f4',
                borderColor: '#FFFFFF',
                iconColor: '#292929',
                alertTextColor: '#4f4f4f',
            },

            // Table Pagination (6 properties)
            pagination: {
                color: '#ffffff',
                backgroundColor: '#1C5888',
                borderColor: '#FFFFFF',
                hoverBackgroundColor: '#1C5888',
                hoverBorderColor: '#ebedf2',
                disabledBorderColor: '#808080FF',
            }
        }
    },

    // ============================================================================
    // MY REPORTS DETAILS COMPONENT (38 properties)
    // Styling for reports listing and detail pages
    // Sections: filter, button (reportButton, badgeButton), pagination, table
    // ============================================================================
    myReportsDetails: {
        color: '#4F4F4F',
        backgroundColor: '#ffffff',

        // --- Filter Section (5 properties) ---
        filter: {
            borderColor: '#dcdcdc',
            borderColorFocus: '#D8F1FF',
            backgroundColor: '#ffffff',
            placeholderColor: '#1C5888',
            labelColor: '#1C5888',
        },

        // --- Button Section (11 properties total) ---
        button: {
            // Report Button (5 properties)
            reportButton: {
                color: '#1C5888',
                backgroundColor: '#ffffff',
                borderColor: '#e0e0e0',
                hoverBackgroundColor: '#f4f4f4',
                hoverColor: '#1C5888',
            },
            // Badge Button (3 properties)
            badgeButton: {
                color: '#1C5888',
                backgroundColor: '#ffffff',
                borderColor: '#e0e0e0',
            }
        },

        // --- Pagination Section (2 properties) ---
        pagination: {
            color: '#ffffff',
            backgroundColor: '#1C5888',
            borderColor: '#FFFFFF',
            hoverBackgroundColor: '#1C5888',
            hoverBorderColor: '#ebedf2',
            disabledBorderColor: '#808080FF',
        },

        // --- Table Section (4 properties) ---
        table: {
            header: {
                color: '#4F4F4F',
                backgroundColor: '#f4f4f4',
                borderRightColor: '#f4f4f4',
                borderBottomColor: '#f4f4f4',
            }
        }
    },

    // ============================================================================
    // MY EXERCISES LIST COMPONENT (50 properties)
    // Styling for exercises listing page
    // Sections: filter, badge, button (viewReportButton, startExerciseButton),
    //           testIdBadge, pagination, table
    // ============================================================================
    myExercisesList: {
        color: '#1C5888',
        backgroundColor: '#ffffff',

        // --- Filter Section (5 properties) ---
        filter: {
            borderColor: '#dcdcdc',
            borderColorFocus: '#D8F1FF',
            backgroundColor: '#ffffff',
            placeholderColor: '#1C5888',
            labelColor: '#1C5888',
        },

        // --- Badge Section (2 properties) ---
        badge: {
            warningBackgroundColor: '#1C5888',
            warningTextColor: '#ffffff',
        },

        // --- Button Section (10 properties total) ---
        button: {
            // View Report Button (5 properties)
            viewReportButton: {
                color: '#1C5888',
                backgroundColor: '#ffffff',
                borderColor: '#e0e0e0',
                hoverBackgroundColor: '#f4f4f4',
                hoverColor: '#1C5888',
            },
            // Start Exercise Button (5 properties)
            startExerciseButton: {
                color: '#ffffff',
                backgroundColor: '#1C5888',
                borderColor: '#1C5888',
                hoverBackgroundColor: '#1C5888',
                hoverColor: '#ffffff',
            }
        },

        // --- Test ID Badge (2 properties) ---
        testIdBadge: {
            backgroundColor: '#e5e5e5',
            textColor: '#ffffff',
        },

        // --- Pagination Section (2 properties) ---
        pagination: {
            color: '#ffffff',
            backgroundColor: '#1C5888',
            borderColor: '#FFFFFF',
            hoverBackgroundColor: '#1C5888',
            hoverBorderColor: '#ebedf2',
            disabledBorderColor: '#808080FF',
        },

        // --- Table Section (4 properties) ---
        table: {
            header: {
                color: '#1C5888',
                backgroundColor: '#D8F1FF',
                borderRightColor: '#B1DCF3',
                borderBottomColor: '#B1DCF3',
            }
        }
    },

    // ============================================================================
    // MY CALENDAR DETAILS COMPONENT (107 properties)
    // Comprehensive calendar view styling with events and modals
    // Sections: container, header (with button), calendar (dayCell, today,
    //           dayHeader, weekend), event, timeGrid, listView,
    //           modal (header, body, meetButton, closeButton)
    // ============================================================================
    myCalendarDetails: {
        // --- Container Section (2 properties) ---
        container: {
            backgroundColor: '#ffffff',
            boxShadowColor: 'rgba(0, 0, 0, 0.1)',
        },

        // --- Header Section (11 properties total) ---
        header: {
            backgroundColor: '#f4f4f4',
            textColor: '#4F4F4F',
            titleColor: '#1C5888',

            // Header Button (7 properties)
            button: {
                backgroundColor: '#ffffff',
                textColor: '#1C5888',
                borderColor: '#d8f1ff',
                hoverBackgroundColor: '#1C5888',
                hoverTextColor: '#ffffff',
                activeBackgroundColor: '#1C5888',
                activeTextColor: '#ffffff',
            }
        },

        // --- Calendar Section (14 properties total) ---
        calendar: {
            // Day Cell (3 properties)
            dayCell: {
                backgroundColor: '#ffffff',
                textColor: '#4F4F4F',
                borderColor: '#e0e0e0',
            },

            // Today Cell (3 properties)
            today: {
                backgroundColor: '#FFFFFF',
                textColor: '#1C5888',
                borderColor: '#1C5888',
            },

            // Day Header (3 properties)
            dayHeader: {
                backgroundColor: '#f4f4f4',
                textColor: '#4F4F4F',
                borderColor: '#e0e0e0',
            },

            // Weekend (1 property)
            weekend: {
                backgroundColor: '#f8f8f8',
            }
        },

        // --- Event Section (9 properties) ---
        event: {
            backgroundColor: '#1C5888',
            textColor: '#ffffff',
            borderColor: '#1C5888',
            hoverBackgroundColor: '#1C5888',
            hoverTextColor: '#ffffff',
            hoverBorderColor: '#014766',
            timeTextColor: '#ffffff',
            titleTextColor: '#ffffff',
            dotColor: '#1C5888',
        },

        // --- Time Grid Section (5 properties) ---
        timeGrid: {
            slotBackgroundColor: '#ffffff',
            slotBorderColor: '#e0e0e0',
            slotTextColor: '#4F4F4F',
            nowIndicatorColor: '#f80f1b',
            slotHoverBackgroundColor: '#FFFFFF',
        },

        // --- List View Section (5 properties) ---
        listView: {
            itemBackgroundColor: '#ffffff',
            itemTextColor: '#4F4F4F',
            itemBorderColor: '#e0e0e0',
            itemHoverBackgroundColor: '#FFFFFF',
            dateTextColor: '#1C5888',
        },

        // --- Modal Section (20 properties total) ---
        modal: {
            backgroundColor: '#ffffff',
            borderColor: '#e0e0e0',

            // Modal Header (2 properties)
            header: {
                backgroundColor: '#f4f4f4',
                textColor: '#1C5888',
            },

            // Modal Body (4 properties)
            body: {
                backgroundColor: '#ffffff',
                textColor: '#4F4F4F',
                labelColor: '#4F4F4F',
                dataColor: '#1C5888',
            },

            // Meet Button (5 properties)
            meetButton: {
                backgroundColor: '#05A14B',
                textColor: '#ffffff',
                hoverBackgroundColor: '#048a3f',
                hoverTextColor: '#ffffff',
                borderColor: '#05A14B',
            },

            // Close Button (5 properties)
            closeButton: {
                backgroundColor: '#f80f1b',
                textColor: '#ffffff',
                hoverBackgroundColor: '#c70e16',
                hoverTextColor: '#ffffff',
                borderColor: '#f80f1b',
            }
        }
    },

    // ============================================================================
    // ASK EMMA COMPONENT (2 properties)
    // Styling for the Ask Emma AI assistant feature
    // ============================================================================
    askEmma: {
        color: '#FAFAFA',
        backgroundColor: '#1C5888',
    },

    // ============================================================================
    // ASSIGNED EXERCISE COMPONENT (5 properties)
    // Styling for assigned exercise buttons and actions
    // Sections: button
    // ============================================================================
    assignedExercise: {
        // --- Button Section (5 properties) ---
        button: {
            color: '#FFFFFF',
            backgroundColor: '#1176b4',
            hoverBackgroundColor: '#0e5f91',
            hoverColor: '#FFFFFF',
            borderColor: '#1176b4',
        }
    },

    // ============================================================================
    // EDIT ASSESSMENT COMPONENT (74 properties)
    // Comprehensive styling for assessment editing interface
    // Sections: container, loading, header, resumeButton, questionTab (default,
    //           active, hover), questionBody, questionContainer, button,
    //           submitButton, dialog
    // ============================================================================
    editAssessment: {
        input: {
            borderColor: '#199ae9',
            focusOutlineColor: '#199ae9',
            focusBorderColor: '#199ae9',

            color: '#000000',
            backgroundColor: '#FFFFFF',

            focusColor: '#000000',
            placeholderColor: '#000000'
        },

        select: {
            borderColor: '#199ae9',
            focusOutlineColor: '#199ae9',
            focusBorderColor: '#199ae9',

            color: '#000000',
            backgroundColor: '#FFFFFF',

            focusColor: '#000000',
            placeholderColor: '#000000'
        },

        // --- Container Section (1 property) ---
        container: {
            backgroundColor: '#F5F6F9',
        },

        // --- Loading Section (1 property) ---
        loading: {
            textColor: '#1C5888',
        },

        // --- Header Section (4 properties) ---
        header: {
            backgroundColor: '#ffffff',
            textColor: '#71717A',
            borderColor: '#ffffff',
            mobileTextColor: '#1C5888',
        },

        // --- Resume Button (4 properties) ---
        resumeButton: {
            backgroundColor: '#1C5888',
            color: 'white',
            fontFamily: 'Poppins, sans-serif',
            fontSize: '1.25rem',
        },

        // --- Question Tab Section (13 properties total) ---
        questionTab: {
            // Default State (4 properties)
            default: {
                backgroundColor: '#ecf8ff',
                textColor: '#403f3f',
                numberBackgroundColor: '#1C5888',
                numberTextColor: '#FFFFFF',
            },
            // Active State (4 properties)
            active: {
                backgroundColor: '#e6e6e6',
                textColor: '#000000',
                numberBackgroundColor: '#c8c8c8',
                numberTextColor: '#000000',
            },
            // Hover State (1 property)
            hover: {
                backgroundColor: '#FFFFFF',
            },
            // Heading (1 property)
            headingColor: '#1C5888',
        },

        // --- Question Body (2 properties) ---
        questionBody: {
            backgroundColor: '#ffffff',
            gridBackgroundColor: '#ffffff',
        },

        // --- Question Container (3 properties) ---
        questionContainer: {
            subgroupHeadingColor: '#014766',
            pageCaptionBackgroundColor: '#FFFFFF',
            pageCaptionTextColor: '#014766',
        },

        // --- Navigation Button (5 properties) ---
        button: {
            color: '#FFFFFF',
            backgroundColor: '#1C5888',
            hoverBackgroundColor: '',
            hoverColor: '',
            borderColor: '',
        },

        // --- Submit Button (2 properties) ---
        submitButton: {
            backgroundColor: '#1C5888',
            textColor: '#ffffff',
        },

        previousButton: {
            backgroundColor: '#1C5888',
            color: '#ffffff',
        },

        nextButton: {
            backgroundColor: '#1C5888',
            color: '#ffffff',
        },

        // --- Dialog Section (5 properties) ---
        dialog: {
            backgroundColor: '#ffffff',
            overlayBackgroundColor: 'rgba(0, 0, 0, 0.5)',
            shadowColor: 'rgba(0, 0, 0, 0.3)',
            headerTextColor: '#1C5888',
            bodyTextColor: '#1C5888',
        }
    },

    // ============================================================================
    // PLANS COMPONENT (13 properties)
    // Styling for subscription plans and billing tabs
    // Sections: tabs (with icon subsection)
    // ============================================================================
    plans: {
        // --- Tabs Section (13 properties total) ---
        tabs: {
            backgroundColor: '#F4F4F4',
            color: '#1C5888',

            activeBackgroundColor: '#1C5888',
            activeColor: '#FFFFFF',

            hoverBackgroundColor: '#E0E0E0',
            hoverColor: '#1C5888',

            borderColor: '',
            activeBorderColor: '',

            historyTabColor: '#1C5888',
            packagesTabColor: '#555',

            // Tab Icons (3 properties)
            icon: {
                activeColor: '#FFFFFF',
                inactiveColor: '#1C5888',
                inactiveFilter: 'brightness(0) saturate(100%) invert(29%) sepia(81%) saturate(731%) hue-rotate(180deg) brightness(101%) contrast(101%)',
            }
        }
    },

    // ============================================================================
    // SIGN IN WRAPPER COMPONENT (34 properties)
    // Comprehensive authentication page styling
    // Sections: container, header, input, icon, checkbox, submitButton,
    //           forgotPasswordLink, signUpLink, termsLink, errorMessage,
    //           alert (danger, success), footer, select, row, column
    // ============================================================================
    signInWrapper: {
        // --- Container Section (2 properties) ---
        container: {
            backgroundColor: '#ffffff',
            boxShadowColor: 'rgba(0, 0, 0, 0.1)',
        },

        // --- Header Section (2 properties) ---
        header: {
            backgroundColor: '#1C5888',
            textColor: '#ffffff',
        },

        // --- Input Section (8 properties) ---
        input: {
            backgroundColor: '#ffffff',
            textColor: '#014B6B',
            borderColor: '#F5F6F9',
            borderColorFocus: '#D8F1FF',
            placeholderColor: '#70AED1',
            labelColor: '#014B6B',
            autofillTextColor: '#014B6B',
            disabledBackgroundColor: '#f6f6f6',
        },

        // --- Icon Section (2 properties) ---
        icon: {
            color: '#70AED1',
            borderColor: '#70AED1',
        },

        // --- Checkbox Section (2 properties) ---
        checkbox: {
            accentColor: '#014B6B',
            outlineColor: '#014B6B',
        },

        // --- Submit Button (4 properties) ---
        submitButton: {
            backgroundColor: '#1C5888',
            color: '#ffffff',
            hoverBackgroundColor: '#014B6B',
            hoverColor: '#ffffff',
        },

        // --- Forgot Password Link (1 property) ---
        forgotPasswordLink: {
            color: '#014B6B',
        },

        // --- Sign Up Link (1 property) ---
        signUpLink: {
            color: '#014766',
        },

        // --- Terms Link (1 property) ---
        termsLink: {
            color: '#1C5888',
        },

        // --- Error Message (1 property) ---
        errorMessage: {
            textColor: '#F80F1B',
        },

        // --- Alert Section (6 properties total) ---
        alert: {
            // Danger Alert (3 properties)
            danger: {
                backgroundColor: '#fff3f3',
                borderColor: '#f5c2c7',
                textColor: '#b00020',
            },
            // Success Alert (3 properties)
            success: {
                backgroundColor: '#f3fff6',
                borderColor: '#c8f7d2',
                textColor: '#1e7d32',
            }
        },

        // --- Footer Section (4 properties) ---
        footer: {
            backgroundColor: '#C7E1EF',
            color: '#ffffff',
            hoverBackgroundColor: '#05A14B',
            hoverColor: '#ffffff',
        },

        // --- Select Section (1 property) ---
        select: {
            placeholderColor: '#70AED1',
        },

        // --- Row Section (1 property) ---
        row: {
            textColor: '#014B6B',
        },

        // --- Column Section (1 property) ---
        column: {
            textColor: '#014B6B',
        }
    },

    biometric: {
        // ============================================================================
        // PAGE WRAPPER (5 properties)
        // ============================================================================
        pageWrapper: {
            backgroundColor: '#FFFFFF',
            textColor: '#09090B',
            borderColor: '#E0E0E0',
        },

        leftSideBar: {
            exerciseContentNthChild: '#D1E7F9',
            // exerciseContentNthChild: '#f4f4f5', //pbn
        },

        // ============================================================================
        // SIDEBAR (9 properties)
        // ============================================================================
        sidebar: {
            backgroundColor: '#F4F4F5',
            headerColor: '#1C5888',
            textColor: '#09090B',
            inactiveTextColor: '#71717A',
            borderColor: '#E0E0E0',
            activeBackgroundColor: '#F4F4F5',
            activeTextColor: '#1C5888',
            hoverBackgroundColor: '#EDEDED',
            hoverTextColor: '#09090B',
            searchBarBackgroundColor: '#0075B6'
        },

        // ============================================================================
        // CAMERA PANEL (12 properties)
        // ============================================================================
        cameraPanel: {
            backgroundColor: '#000000',
            borderColor: '#1C5888',
            calibrationGridColor: '#FF0000',
            overlayOpacity: 0.2,
            cornerHighlightColor: '#1C5888',
            testIdTextColor: '#FFFFFF',
            buttonGroupBackgroundColor: '#F4F4F5',
            buttonColor: '#1C5888',
            buttonHoverColor: '#0E5F91',
            pauseButtonBackgroundColor: '#1C5888',
            pauseButtonTextColor: '#FFFFFF',
            unableButtonBackgroundColor: '#F4F4F5',
        },

        // ============================================================================
        // MOVEMENT GUIDELINE PANEL (7 properties)
        // ============================================================================
        movementGuideline: {
            backgroundColor: '#d9d9d9',
            borderColor: '#E0E0E0',
            textColor: '#09090B',
            titleColor: '#1C5888',
            subtitleColor: '#4F4F4F',
            figureColor: '#1C5888',
            instructionTextColor: '#4F4F4F',
        },

        // ============================================================================
        // HEADER BAR (6 properties)
        // ============================================================================
        headerBar: {
            backgroundColor: '#FFFFFF',
            textColor: '#09090B',
            highlightTextColor: '#1C5888',
            linkColor: '#1C5888',
            linkHoverColor: '#0E5F91',
        },
        // ============================================================================
        // Global
        // ============================================================================
        global: {
            backgroundColor: '#1C5888',
            textColor: '#fff',
        },

        // ============================================================================
        // BUTTON STYLES (6 properties)
        // ============================================================================
        button: {
            primaryBackgroundColor: '#1C5888',
            primaryTextColor: '#FFFFFF',
            primaryHoverBackgroundColor: '#0E5F91',
            secondaryBackgroundColor: '#F4F4F5',
            secondaryTextColor: '#09090B',
            secondaryHoverBackgroundColor: '#EDEDED',
        },

        // ============================================================================
        // STATUS TAGS (3 properties)
        // ============================================================================
        statusTag: {
            performingColor: '#1C5888',
            completedColor: '#05A14B',
            pendingColor: '#DCDCDC',
        },
    },
    //stgvatb
    chatBot: {
        modal: {
            backgroundColor: '#FFFFFF',
        },

        backgroundColor: '#FFFFFF',
        chatBotHeaderColor: '#000000',

        saveAndCloseButton: {
          color: '#FFFFFF',
          backgroundColor: '#02C939',
        },

        info: {
            backgroundColor: '#FFFFFF',
        },

        container: {
            backgroundColor: '#FFFFFF',
        },

        input: {
            focusOutlineColor: '#199ae9',
            focusBorderColor: '#199ae9',
        },

        primaryColor: '#0E5F91',
        titleColor: '#3BA7E2',
        primaryColorHover: '#0E5F91',
        primaryBackgroundColor: '#014766',
        primaryBackgroundColorHover: '#F4F4F5',

        chatBotHeaderBackgroundColor: '#0075b6',
        chatBotMicBackgroundColor: '#014766',

        bodyTestBackgroundColor: '#E7F1F7',
        bodyTestTextColor: '#014766',

        prevBackgroundColor: '#3ba7e2',
        prevBtnBackgroundColor: '#3ba7e2',
        editBtnBackgroundColor: '#05A14B',

        successBackgroundColor: '#05A14B',
        successBackgroundColorHover: '#048A3F',
        successColor: '#FFFFFF',
        successColorHover: '#FFFFFF',

        primaryLightColor: '#3BA7E2',
        primaryLightColorHover: '#3BA7E2',
        primaryLightBackgroundColor: '#E7F1F7',
        primaryLightBackgroundColorHover: '#D8ECFC',

        selectedOutlinedButton: {
            color: '#FFFFFF',
            backgroundColor: '#3BA7E2',
        },

        primaryDisabledColor: '#B0BEC5',
        primaryDisabledColorHover: '#A0AEB5',
        primaryDisabledBackgroundColor: '#ECEFF1',
        primaryDisabledBackgroundColorHover: '#E0E4E7',
    },

    //stgpbn
    // chatBot: {
    //     input: {
    //         focusOutlineColor: '#199ae9',
    //         focusBorderColor: '#199ae9',
    //     },
    //     primaryColor: '#000000',
    //     titleColor: '#000000',
    //     primaryColorHover: '#0E5F91',
    //     primaryBackgroundColor: '#014766',
    //     primaryBackgroundColorHover: '#F4F4F5',
    //
    //     chatBotHeaderBackgroundColor: '#ffffff',
    //
    //     chatBotMicBackgroundColor: '#014766',
    //
    //     bodyTestBackgroundColor: '#e4e4e7',
    //     bodyTestTextColor: '#000000',
    //
    //     prevBackgroundColor: '#c8c8c8',
    //     prevBtnBackgroundColor: '#1C5888',
    //     editBtnBackgroundColor: '#3AAA37',
    //
    //     successBackgroundColor: '#3AAA37',
    //     successBackgroundColorHover: '#048A3F',
    //     successColor: '#FFFFFF',
    //     successColorHover: '#FFFFFF',
    //
    //     primaryLightColor: '#1C5888',
    //     primaryLightColorHover: '#1C5888',
    //     primaryLightBackgroundColor: '#E7F1F7',
    //     primaryLightBackgroundColorHover: '#D8ECFC',
    //
    //     primaryDisabledColor: '#B0BEC5',
    //     primaryDisabledColorHover: '#A0AEB5',
    //     primaryDisabledBackgroundColor: '#ECEFF1',
    //     primaryDisabledBackgroundColorHover: '#E0E4E7',
    // },

    alertModal: {
        backgroundColor: '#FFFFFF',

        overlayBackgroundColor: 'rgba(0, 0, 0, 0.5)',
        containerBackgroundColor: '#ffffff',
        containerBorderRadius: '12px',
        containerBoxShadow: '0 10px 40px rgba(0, 0, 0, 0.15)',

        // Close Button
        closeColor: '#828282', // medium gray
        closeHoverColor: '#4F4F4F', // dark gray
        closeFocusOutlineColor: '#0075B6', // primary

        // Icon
        iconBackgroundColor: '#0075B6', // primary
        iconColor: '#ffffff', // white

        // Title
        titleColor: '#4F4F4F', // dark gray
        titleFontSize: '1.25rem',

        // Description
        descriptionColor: '#828282', // medium gray
        descriptionBackgroundColor: '#ECF8FF', // ice blue
        descriptionFontSize: '0.875rem',

        // Button Styles
        buttonPrimaryBackgroundColor: '#0075B6', // primary
        buttonPrimaryColor: '#ffffff', // white
        buttonPrimaryHoverBackgroundColor: '#014766', // primary dark 1

        buttonSecondaryBackgroundColor: '#70AED1', // secondary
        buttonSecondaryColor: '#ffffff', // white
        buttonSecondaryHoverBackgroundColor: '#94BDD3', // secondary dark

        buttonOutlineColor: '#0075B6', // primary
        buttonOutlineBorderColor: '#0075B6', // primary
        buttonOutlineHoverBackgroundColor: '#F4F4F4', // light gray 1

        buttonGhostColor: '#828282', // medium gray
        buttonGhostHoverBackgroundColor: '#F4F4F4', // light gray 1
        buttonGhostFocusOutlineColor: '#828282', // medium gray
    },

    cautionModal: {
        quesColor: '#014766',
    },

    // stg
    intakeForm: {
        titleColor: '#0075b6',
        textColor: '#1176B4',
        labelColor: '#1176B4',
        inputTextColor: '#1176B4',
        inputBackgroundColor: '#ffffff',
        inputBorderColor: '#014766',
    },

    // // pbn
    // intakeForm: {
    //     titleColor: '#1C5888',
    //     textColor: '#000000',
    //     labelColor: '#000000',
    //     inputTextColor: '#000000',
    //     inputBackgroundColor: '#ffffff',
    //     inputBorderColor: '#000000',
    // }
};

/**
 * Apply colors to CSS custom properties
 */
function applyColors(colors) {
    const root = document.documentElement;

    const styleMap = {
        '--text-color': colors?.textColor,
        '--global-background-color': colors?.globalBackgroundColor,

        '--color-primary': colors?.primary,
        '--color-primary-light-1': colors?.primaryLight1,
        '--color-primary-light-2': colors?.primaryLight2,
        '--color-primary-dark-1': colors?.primaryDark1,
        '--color-primary-dark-2': colors?.primaryDark2,

        '--color-secondary': colors?.secondary,
        '--color-secondary-light': colors?.secondaryLight,
        '--color-secondary-dark': colors?.secondaryDark,

        '--color-white': colors?.white,
        '--color-black': colors?.black,
        '--color-white-dark': colors?.whiteDark,

        '--color-gray': colors?.gray,
        '--color-dark-gray': colors?.darkGray,
        '--color-light-gray': colors?.lightGray,
        '--color-medium-gray': colors?.mediumGray,

        '--color-red': colors?.red,
        '--color-light-red': colors?.lightRed,
        '--color-dark-red': colors?.darkRed,

        '--color-green': colors?.green,
        '--color-light-green': colors?.lightGreen,

        '--color-orange-yellow': colors?.orangeYellow,
        '--color-orange-dark': colors?.orangeDark,

        '--color-ice-blue': colors?.iceBlue,
        '--color-ice-blue-2': colors?.iceBlue2,
        '--color-ice-blue-3': colors?.iceBlue3,
        '--color-ice-blue-4': colors?.iceBlue4,
    };

    Object.entries(styleMap).forEach(([key, value]) => {
        if (value) root.style.setProperty(key, value);
    });
}

/**
 * Apply typography to CSS custom properties
 */
function applyTypography(typography) {
    const root = document.documentElement;

    const styleMap = {
        // Font families
        '--font-primary': typography?.fontFamily?.primary,
        '--font-secondary': typography?.fontFamily?.secondary,
        '--font-tertiary': typography?.fontFamily?.tertiary,

        // Font sizes
        '--font-size-heading-lg': typography?.fontSizes?.headingLg,
        '--font-size-heading-md': typography?.fontSizes?.headingMd,
        '--font-size-heading-sm': typography?.fontSizes?.headingSm,
        '--font-size-xl': typography?.fontSizes?.xl,
        '--font-size-lg': typography?.fontSizes?.lg,
        '--font-size-md': typography?.fontSizes?.md,
        '--font-size-sm': typography?.fontSizes?.sm,
        '--font-size-xs': typography?.fontSizes?.xs,

        // Font weights
        '--font-weight-light': typography?.fontWeights?.light,
        '--font-weight-regular': typography?.fontWeights?.regular,
        '--font-weight-medium': typography?.fontWeights?.medium,
        '--font-weight-semibold': typography?.fontWeights?.semibold,
        '--font-weight-bold': typography?.fontWeights?.bold,
    };

    Object.entries(styleMap).forEach(([key, value]) => {
        if (value) root.style.setProperty(key, value);
    });
}

function applyComponentsStyle(styles) {
    const root = document.documentElement;

    const styleMap = {
        // Mobile app suggestion
        '--mobile-app-suggestion-color': styles?.mobileAppSuggestion?.color,
        '--mobile-app-suggestion-background-color': styles?.mobileAppSuggestion?.backgroundColor,

        // Report Modal
        '--report-text-color': styles?.report?.textColor,
        '--report-color-ice-blue-4': styles?.report?.iceBlue4,

        // Standard Medical Theme Colors
        '--report-color-standard-blue': styles?.report?.standardBlue,
        '--report-color-standard-blue-dark': styles?.report?.standardBlueDark,
        '--report-color-standard-blue-light': styles?.report?.standardBlueLight,

        // Universal Status Colors
        '--report-status-abnormal': styles?.report?.statusAbnormal,
        '--report-status-normal': styles?.report?.statusNormal,
        '--report-status-warning': styles?.report?.statusWarning,
        '--report-status-within': styles?.report?.statusWithin,
        '--report-status-below': styles?.report?.statusBelow,
        '--report-status-above': styles?.report?.statusAbove,

        // UI Foundation Colors
        '--report-text-primary': styles?.report?.textPrimary,
        '--report-text-secondary': styles?.report?.textSecondary,
        '--report-border-color': styles?.report?.borderColor,
        '--report-bg-light': styles?.report?.bgLight,


        // Custom Modal
        '--alert-modal-background-color': styles.alertModal?.backgroundColor,

        '--custom-modal-background-color': styles.customModal?.backgroundColor,
        '--custom-modal-header-background-color': styles.customModal?.headerBackgroundColor,

        '--payment-modal-background-color': styles.paymentModal?.backgroundColor,

        '--payment-modal-success-background-color': styles.paymentModal?.successBackgroundColor,
        '--payment-modal-success-color': styles.paymentModal?.successColor,

        '--payment-modal-failed-background-color': styles.paymentModal?.failedBackgroundColor,
        '--payment-modal-failed-color': styles.paymentModal?.failedColor,

        '--chatbot-modal-background-color': styles?.chatBot?.modal?.backgroundColor,
        '--chatbot-container-background-color': styles?.chatBot?.container?.backgroundColor,
        '--chatbot-info-background-color': styles?.chatBot?.info?.backgroundColor,

        // Tab Menu
        '--tab-menu-hover-background-color': styles.tabMenu?.hoverBackgroundColor,
        '--tab-menu-color': styles.tabMenu?.color,
        '--tab-menu-active-color': styles.tabMenu?.activeColor,
        '--tab-menu-active-background-color': styles.tabMenu?.activeBackgroundColor,
        '--tab-menu-background-color': styles.tabMenu?.backgroundColor,
        '--tab-menu-hover-color': styles.tabMenu?.hoverColor,
        '--tab-menu-border-color': styles.tabMenu?.borderColor,
        '--tab-menu-active-border-color': styles.tabMenu?.activeBorderColor,
        '--tab-menu-hover-border-color': styles.tabMenu?.hoverBorderColor,

        '--signin-signup-input-border-color': styles.signinSignup?.input?.borderColor,
        '--signin-signup-input-color': styles.signinSignup?.input?.color,

        '--signup-signin-header-color': styles.signinSignup?.header?.color,

        // Signup signin button
        '--signin-signup-input-placeholder-color': styles.signinSignup?.input?.placeholderColor,
        '--signup-signin-submit-button-background-color': styles.signinSignup?.submitButton?.backgroundColor,
        '--signup-signin-submit-button-color': styles.signinSignup?.submitButton?.color,
        '--signup-signin-link-text-color': styles.signinSignup?.linkText?.color,

        // Main Header Wrapper
        '--main-header-wrapper-background-color': styles.mainHeaderWrapper?.backgroundColor,
        '--main-header-wrapper-dropdown-background-color': styles.mainHeaderWrapper?.dropdown?.backgroundColor,

        '--main-header-wrapper-sign-up-link-background-color': styles.mainHeaderWrapper?.signUpLink?.backgroundColor,
        '--main-header-wrapper-sign-up-link-color': styles.mainHeaderWrapper?.signUpLink?.color,

        '--main-header-wrapper-language-dropdown-background-color': styles.mainHeaderWrapper?.languageDropdown?.backgroundColor,
        '--main-header-wrapper-language-dropdown-color': styles.mainHeaderWrapper?.languageDropdown?.color,

        '--main-header-wrapper-user-dropdown-background-color': styles.mainHeaderWrapper?.userDropdown?.backgroundColor,
        '--main-header-wrapper-user-dropdown-color': styles.mainHeaderWrapper?.userDropdown?.color,

        '--main-header-wrapper-dropdown-color': styles.mainHeaderWrapper?.dropdown?.color,
        '--main-header-wrapper-dropdown-border-color': styles.mainHeaderWrapper?.dropdown?.borderColor,
        '--main-header-wrapper-dropdown-hover-background-color': styles.mainHeaderWrapper?.dropdown?.hoverBackgroundColor,
        '--main-header-wrapper-dropdown-hover-color': styles.mainHeaderWrapper?.dropdown?.hoverColor,
        '--main-header-wrapper-nav-item-active-background-color': styles.mainHeaderWrapper?.navItemActive?.backgroundColor,
        '--main-header-wrapper-nav-item-active-color': styles.mainHeaderWrapper?.navItemActive?.color,
        '--main-header-wrapper-user-profile-border-color': styles.mainHeaderWrapper?.userProfile?.borderColor,
        '--main-header-wrapper-user-profile-name-color': styles.mainHeaderWrapper?.userProfile?.nameColor,
        '--main-header-wrapper-user-profile-delete-text-color': styles.mainHeaderWrapper?.userProfile?.deleteTextColor,
        '--main-header-wrapper-badge-background-color': styles.mainHeaderWrapper?.badge?.backgroundColor,
        '--main-header-wrapper-badge-color': styles.mainHeaderWrapper?.badge?.color,
        '--main-header-wrapper-logout-button-background-color': styles.mainHeaderWrapper?.logoutButton?.backgroundColor,
        '--main-header-wrapper-logout-button-color': styles.mainHeaderWrapper?.logoutButton?.color,
        '--main-header-wrapper-logout-button-hover-background-color': styles.mainHeaderWrapper?.logoutButton?.hoverBackgroundColor,
        '--main-header-wrapper-logout-button-hover-color': styles.mainHeaderWrapper?.logoutButton?.hoverColor,
        '--main-header-wrapper-movement-toggle-button-background-color': styles.mainHeaderWrapper?.movementToggleButton?.backgroundColor,
        '--main-header-wrapper-movement-toggle-button-color': styles.mainHeaderWrapper?.movementToggleButton?.color,
        '--main-header-wrapper-back-to-mybackhub-button-color': styles.mainHeaderWrapper?.backToMyBackHubButton?.color,
        '--main-header-wrapper-back-to-mybackhub-button-border-color': styles.mainHeaderWrapper?.backToMyBackHubButton?.borderColor,
        '--main-header-wrapper-back-to-mybackhub-button-hover-background-color': styles.mainHeaderWrapper?.backToMyBackHubButton?.hoverBackgroundColor,
        '--main-header-wrapper-back-to-mybackhub-button-hover-color': styles.mainHeaderWrapper?.backToMyBackHubButton?.hoverColor,
        '--main-header-wrapper-back-to-mybackhub-button-mobile-color': styles.mainHeaderWrapper?.backToMyBackHubButton?.mobileColor,
        '--main-header-wrapper-mobile-toggle-icon-color': styles.mainHeaderWrapper?.mobileToggle?.iconColor,

        // New Assessment Invitation
        '--new-assessments-invitation-dashboard-item-sepbar-color': styles.newAssessmentInvitation?.dashboardItemSpepbarContainer?.borderColor,
        '--new-assessments-invitation-background-color': styles.newAssessmentInvitation?.backgroundColor,
        '--new-assessments-invitation-color': styles.newAssessmentInvitation?.color,
        '--new-assessment-button-background-color': styles.newAssessmentInvitation?.button?.backgroundColor,
        '--new-assessment-button-color': styles.newAssessmentInvitation?.button?.color,
        '--new-assessment-button-hover-background-color': styles.newAssessmentInvitation?.button?.hoverBackgroundColor,
        '--new-assessment-button-hover-color': styles.newAssessmentInvitation?.button?.hoverColor,

        // Dashboard/New Assessment Invitation - Table Header
        '--dashboard-table-header-color': styles.newAssessmentInvitation?.table?.header?.color,
        '--dashboard-table-header-background-color': styles.newAssessmentInvitation?.table?.header?.backgroundColor,
        '--dashboard-table-header-border-bottom-color': styles.newAssessmentInvitation?.table?.header?.borderBottomColor,

        '--mmh-table-header-background-color': styles.mmhTable?.header?.backgroundColor,

        // MMH Table outlined buttons
        '--dashboard-table-header-border-right-color': styles.newAssessmentInvitation?.table?.header?.borderRightColor,
        '--mmh-table-outlined-button-background-color': styles.mmhTable?.outlinedButton?.backgroundColor,
        '--mmh-table-outlined-button-color': styles.mmhTable?.outlinedButton?.color,
        '--mmh-table-outlined-button-hover-background-color': styles.mmhTable?.outlinedButton?.hoverBackgroundColor,
        '--mmh-table-outlined-button-hover-color': styles.mmhTable?.outlinedButton?.hoverColor,
        '--mmh-table-outlined-button-border-color': styles.mmhTable?.outlinedButton?.borderColor,

        // MMH Table solid buttons
        '--mmh-table-solid-button-background-color': styles.mmhTable?.solidButton?.backgroundColor,
        '--mmh-table-solid-button-selected-background-color': styles.mmhTable?.solidButton?.selectedBackgroundColor,
        '--mmh-table-solid-button-selected-border-color': styles.mmhTable?.solidButton?.selectedBorderColor,
        '--mmh-table-solid-button-color': styles.mmhTable?.solidButton?.color,
        '--mmh-table-solid-button-hover-background-color': styles.mmhTable?.solidButton?.hoverBackgroundColor,
        '--mmh-table-solid-button-hover-color': styles.mmhTable?.solidButton?.hoverColor,
        '--mmh-table-solid-button-border-color': styles.mmhTable?.solidButton?.borderColor,
        '--mmh-table-checkbox-button-border-color': styles.mmhTable?.checkboxButtonBorderColor?.color,
        '--mmh-table-checkbox-button-background-color': styles.mmhTable?.mmhTableCheckboxButton?.backgroundColor,
        '--mmh-table-checkbox-button-color': styles.mmhTable?.mmhTableCheckboxButton?.color,

        // My Assessments Detail
        '--my-assessments-detail-color': styles.myAssessmentsDetail?.color,
        '--my-assessments-detail-background-color': styles.myAssessmentsDetail?.backgroundColor,

        // Filter Section
        '--my-assessments-detail-filter-border-color': styles.myAssessmentsDetail?.filter?.borderColor,
        '--my-assessments-detail-filter-border-color-focus': styles.myAssessmentsDetail?.filter?.borderColorFocus,
        '--my-assessments-detail-filter-background-color': styles.myAssessmentsDetail?.filter?.backgroundColor,
        '--my-assessments-detail-filter-placeholder-color': styles.myAssessmentsDetail?.filter?.placeholderColor,
        '--my-assessments-detail-filter-label-color': styles.myAssessmentsDetail?.filter?.labelColor,

        // Badge
        '--my-assessments-detail-badge-warning-background-color': styles.myAssessmentsDetail?.badge?.warningBackgroundColor,
        '--my-assessments-detail-badge-warning-text-color': styles.myAssessmentsDetail?.badge?.warningTextColor,

        // Primary Button
        '--my-assessments-detail-primary-button-background-color': styles.myAssessmentsDetail?.primaryButton?.backgroundColor,
        '--my-assessments-detail-primary-button-color': styles.myAssessmentsDetail?.primaryButton?.color,
        '--my-assessments-detail-primary-button-hover-background-color': styles.myAssessmentsDetail?.primaryButton?.hoverBackgroundColor,
        '--my-assessments-detail-primary-button-hover-color': styles.myAssessmentsDetail?.primaryButton?.hoverColor,

        // Success Button
        '--my-assessments-detail-success-button-background-color': styles.myAssessmentsDetail?.successButton?.backgroundColor,
        '--my-assessments-detail-success-button-color': styles.myAssessmentsDetail?.successButton?.color,
        '--my-assessments-detail-success-button-hover-background-color': styles.myAssessmentsDetail?.successButton?.hoverBackgroundColor,
        '--my-assessments-detail-success-button-hover-color': styles.myAssessmentsDetail?.successButton?.hoverColor,

        // Danger Button
        '--my-assessments-detail-danger-button-background-color': styles.myAssessmentsDetail?.dangerButton?.backgroundColor,
        '--my-assessments-detail-danger-button-color': styles.myAssessmentsDetail?.dangerButton?.color,
        '--my-assessments-detail-danger-button-hover-background-color': styles.myAssessmentsDetail?.dangerButton?.hoverBackgroundColor,
        '--my-assessments-detail-danger-button-hover-color': styles.myAssessmentsDetail?.dangerButton?.hoverColor,

        // Spinner
        '--my-assessments-detail-spinner-border-color': styles.myAssessmentsDetail?.spinner?.borderColor,
        '--my-assessments-detail-spinner-accent-color': styles.myAssessmentsDetail?.spinner?.accentColor,

        // Container
        '--my-assessments-detail-container-background-color': styles.myAssessmentsDetail?.container?.backgroundColor,
        '--my-assessments-detail-container-border-color': styles.myAssessmentsDetail?.container?.borderColor,

        // Empty State
        '--my-assessments-detail-empty-state-text-color': styles.myAssessmentsDetail?.emptyState?.textColor,
        '--my-assessments-detail-empty-state-font-size': styles.myAssessmentsDetail?.emptyState?.fontSize,

        // Table Header
        '--my-assessments-detail-table-header-color': styles.myAssessmentsDetail?.table?.header?.color,
        '--my-assessments-detail-table-header-background-color': styles.myAssessmentsDetail?.table?.header?.backgroundColor,
        '--my-assessments-detail-table-header-border-bottom-color': styles.myAssessmentsDetail?.table?.header?.borderBottomColor,
        '--my-assessments-detail-table-header-border-right-color': styles.myAssessmentsDetail?.table?.header?.borderRightColor,

        // Table Body
        '--my-assessments-detail-table-body-row-border-bottom-color': styles.myAssessmentsDetail?.table?.body?.row?.borderBottomColor,
        '--my-assessments-detail-table-body-row-nth-child-2n-background-color': styles.myAssessmentsDetail?.table?.body?.row?.nthChild2n?.backgroundColor,

        // Table Loader
        '--my-assessments-detail-table-loader-background-color': styles.myAssessmentsDetail?.table?.loader?.backgroundColor,
        '--my-assessments-detail-table-loader-color': styles.myAssessmentsDetail?.table?.loader?.color,
        '--my-assessments-detail-table-loader-border-color': styles.myAssessmentsDetail?.table?.loader?.borderColor,
        '--my-assessments-detail-table-loader-icon-color': styles.myAssessmentsDetail?.table?.loader?.iconColor,
        '--my-assessments-detail-table-loader-alert-text-color': styles.myAssessmentsDetail?.table?.loader?.alertTextColor,

        // Table Pagination
        '--my-assessments-detail-table-pagination-color': styles.myAssessmentsDetail?.table?.pagination?.color,
        '--my-assessments-detail-table-pagination-border-color': styles.myAssessmentsDetail?.table?.pagination?.borderColor,
        '--my-assessments-detail-table-pagination-background-color': styles.myAssessmentsDetail?.table?.pagination?.backgroundColor,
        '--my-assessments-detail-table-pagination-hover-background-color': styles.myAssessmentsDetail?.table?.pagination?.hoverBackgroundColor,
        '--my-assessments-detail-table-pagination-hover-border-color': styles.myAssessmentsDetail?.table?.pagination?.hoverBorderColor,
        '--my-assessments-detail-table-pagination-disabled-border-color': styles.myAssessmentsDetail?.table?.pagination?.disabledBorderColor,

        '--select-option-border-color': styles.selectOption?.borderColor,
        '--select-option-background-color': styles.selectOption?.backgroundColor,

        '--pagination-background-color': styles.pagination?.backgroundColor,
        '--pagination-color': styles.pagination?.color,

        // My Reports Detail
        '--my-reports-details-color': styles.myReportsDetails?.color,
        '--my-reports-details-background-color': styles.myReportsDetails?.backgroundColor,

        // My Reports Details - Filter Section
        '--my-reports-details-filter-border-color': styles.myReportsDetails?.filter?.borderColor,
        '--my-reports-details-filter-border-color-focus': styles.myReportsDetails?.filter?.borderColorFocus,
        '--my-reports-details-filter-background-color': styles.myReportsDetails?.filter?.backgroundColor,
        '--my-reports-details-filter-placeholder-color': styles.myReportsDetails?.filter?.placeholderColor,
        '--my-reports-details-filter-label-color': styles.myReportsDetails?.filter?.labelColor,

        // My Reports Detail - Report Button
        '--my-reports-details-report-button-color': styles.myReportsDetails?.button?.reportButton?.color,
        '--my-reports-details-report-button-background-color': styles.myReportsDetails?.button?.reportButton?.backgroundColor,
        '--my-reports-details-report-button-border-color': styles.myReportsDetails?.button?.reportButton?.borderColor,
        '--my-reports-details-report-button-hover-background-color': styles.myReportsDetails?.button?.reportButton?.hoverBackgroundColor,
        '--my-reports-details-report-button-hover-color': styles.myReportsDetails?.button?.reportButton?.hoverColor,

        // My Reports Detail - Badge Button
        '--my-reports-details-badge-button-color': styles.myReportsDetails?.button?.badgeButton?.color,
        '--my-reports-details-badge-button-background-color': styles.myReportsDetails?.button?.badgeButton?.backgroundColor,
        '--my-reports-details-badge-button-border-color': styles.myReportsDetails?.button?.badgeButton?.borderColor,

        // My Reports Detail - Pagination
        '--my-reports-details-pagination-info-text-color': styles.myReportsDetails?.pagination?.infoTextColor,
        '--my-reports-details-pagination-select-border-color': styles.myReportsDetails?.pagination?.selectBorderColor,

        // My Reports Detail - Table Header
        '--my-reports-details-table-header-color': styles.myReportsDetails?.table?.header?.color,
        '--my-reports-details-table-header-background-color': styles.myReportsDetails?.table?.header?.backgroundColor,
        '--my-reports-details-table-header-border-bottom-color': styles.myReportsDetails?.table?.header?.borderBottomColor,
        '--my-reports-details-table-header-border-right-color': styles.myReportsDetails?.table?.header?.borderRightColor,

        // My Exercises List
        '--my-exercises-list-color': styles.myExercisesList?.color,
        '--my-exercises-list-background-color': styles.myExercisesList?.backgroundColor,

        // My Exercises List - Filter Section
        '--my-exercises-list-filter-border-color': styles.myExercisesList?.filter?.borderColor,
        '--my-exercises-list-filter-border-color-focus': styles.myExercisesList?.filter?.borderColorFocus,
        '--my-exercises-list-filter-background-color': styles.myExercisesList?.filter?.backgroundColor,
        '--my-exercises-list-filter-placeholder-color': styles.myExercisesList?.filter?.placeholderColor,
        '--my-exercises-list-filter-label-color': styles.myExercisesList?.filter?.labelColor,

        // My Exercises List - Badge
        '--my-exercises-list-badge-warning-background-color': styles.myExercisesList?.badge?.warningBackgroundColor,
        '--my-exercises-list-badge-warning-text-color': styles.myExercisesList?.badge?.warningTextColor,

        // My Exercises List - View Report Button
        '--my-exercises-list-view-report-button-color': styles.myExercisesList?.button?.viewReportButton?.color,
        '--my-exercises-list-view-report-button-background-color': styles.myExercisesList?.button?.viewReportButton?.backgroundColor,
        '--my-exercises-list-view-report-button-border-color': styles.myExercisesList?.button?.viewReportButton?.borderColor,
        '--my-exercises-list-view-report-button-hover-background-color': styles.myExercisesList?.button?.viewReportButton?.hoverBackgroundColor,
        '--my-exercises-list-view-report-button-hover-color': styles.myExercisesList?.button?.viewReportButton?.hoverColor,

        // My Exercises List - Start Exercise Button
        '--my-exercises-list-start-exercise-button-color': styles.myExercisesList?.button?.startExerciseButton?.color,
        '--my-exercises-list-start-exercise-button-background-color': styles.myExercisesList?.button?.startExerciseButton?.backgroundColor,
        '--my-exercises-list-start-exercise-button-border-color': styles.myExercisesList?.button?.startExerciseButton?.borderColor,
        '--my-exercises-list-start-exercise-button-hover-background-color': styles.myExercisesList?.button?.startExerciseButton?.hoverBackgroundColor,
        '--my-exercises-list-start-exercise-button-hover-color': styles.myExercisesList?.button?.startExerciseButton?.hoverColor,

        // My Exercises List - Test ID Badge
        '--my-exercises-list-test-id-badge-background-color': styles.myExercisesList?.testIdBadge?.backgroundColor,
        '--my-exercises-list-test-id-badge-text-color': styles.myExercisesList?.testIdBadge?.textColor,

        // My Exercises List - Pagination
        '--my-exercises-list-pagination-info-text-color': styles.myExercisesList?.pagination?.infoTextColor,
        '--my-exercises-list-pagination-select-border-color': styles.myExercisesList?.pagination?.selectBorderColor,

        // My Exercises List - Table Header
        '--my-exercises-list-table-header-color': styles.myExercisesList?.table?.header?.color,
        '--my-exercises-list-table-header-background-color': styles.myExercisesList?.table?.header?.backgroundColor,
        '--my-exercises-list-table-header-border-bottom-color': styles.myExercisesList?.table?.header?.borderBottomColor,
        '--my-exercises-list-table-header-border-right-color': styles.myExercisesList?.table?.header?.borderRightColor,

        // Ask Emma
        '--ask-emma-color': styles.askEmma?.color,
        '--ask-emma-background-color': styles.askEmma?.backgroundColor,

        // Assigned Exercise Button
        '--assigned-exercise-button-color': styles.assignedExercise?.button?.color,
        '--assigned-exercise-button-background-color': styles.assignedExercise?.button?.backgroundColor,
        '--assigned-exercise-button-hover-background-color': styles.assignedExercise?.button?.hoverBackgroundColor,
        '--assigned-exercise-button-hover-color': styles.assignedExercise?.button?.hoverColor,
        '--assigned-exercise-button-border-color': styles.assignedExercise?.button?.borderColor,

        // Edit Assessment - Container
        '--edit-assessment-input-border-color': styles.editAssessment?.input?.borderColor,
        '--edit-assessment-input-focus-outline-color': styles.editAssessment?.input?.focusOutlineColor,
        '--edit-assessment-input-focus-border-color': styles.editAssessment?.input?.focusBorderColor,
        '--edit-assessment-input-color': styles.editAssessment?.input?.color,
        '--edit-assessment-input-focus-color': styles.editAssessment?.input?.focusColor,
        '--edit-assessment-input-placeholder-color': styles.editAssessment?.input?.placeholderColor,
        '--edit-assessment-input-background-color': styles.editAssessment?.input?.backgroundColor,

        '--edit-assessment-select-border-color': styles.editAssessment?.select?.borderColor,
        '--edit-assessment-select-focus-outline-color': styles.editAssessment?.select?.focusOutlineColor,
        '--edit-assessment-select-focus-border-color': styles.editAssessment?.select?.focusBorderColor,
        '--edit-assessment-select-color': styles.editAssessment?.select?.color,
        '--edit-assessment-select-focus-color': styles.editAssessment?.select?.focusColor,
        '--edit-assessment-select-placeholder-color': styles.editAssessment?.select?.placeholderColor,
        '--edit-assessment-select-background-color': styles.editAssessment?.select?.backgroundColor,

        '--edit-assessment-container-background-color': styles.editAssessment?.container?.backgroundColor,

        // Edit Assessment - Loading
        '--edit-assessment-loading-text-color': styles.editAssessment?.loading?.textColor,

        // Edit Assessment - Header
        '--edit-assessment-header-background-color': styles.editAssessment?.header?.backgroundColor,
        '--edit-assessment-header-text-color': styles.editAssessment?.header?.textColor,
        '--edit-assessment-header-border-color': styles.editAssessment?.header?.borderColor,
        '--edit-assessment-header-mobile-text-color': styles.editAssessment?.header?.mobileTextColor,

        // Edit Assessment - Resume Button
        '--edit-assessment-resume-button-background-color': styles.editAssessment?.resumeButton?.backgroundColor,
        '--edit-assessment-resume-button-color': styles.editAssessment?.resumeButton?.color,
        '--edit-assessment-resume-button-font-family': styles.editAssessment?.resumeButton?.fontFamily,
        '--edit-assessment-resume-button-font-size': styles.editAssessment?.resumeButton?.fontSize,

        // Edit Assessment - Question Tab Default
        '--edit-assessment-question-tab-default-background-color': styles.editAssessment?.questionTab?.default?.backgroundColor,
        '--edit-assessment-question-tab-default-text-color': styles.editAssessment?.questionTab?.default?.textColor,
        '--edit-assessment-question-tab-default-number-background-color': styles.editAssessment?.questionTab?.default?.numberBackgroundColor,
        '--edit-assessment-question-tab-default-number-text-color': styles.editAssessment?.questionTab?.default?.numberTextColor,

        // Edit Assessment - Question Tab Active
        '--edit-assessment-question-tab-active-background-color': styles.editAssessment?.questionTab?.active?.backgroundColor,
        '--edit-assessment-question-tab-active-text-color': styles.editAssessment?.questionTab?.active?.textColor,
        '--edit-assessment-question-tab-active-number-background-color': styles.editAssessment?.questionTab?.active?.numberBackgroundColor,
        '--edit-assessment-question-tab-active-number-text-color': styles.editAssessment?.questionTab?.active?.numberTextColor,

        // Edit Assessment - Question Tab Hover
        '--edit-assessment-question-tab-hover-background-color': styles.editAssessment?.questionTab?.hover?.backgroundColor,

        // Edit Assessment - Question Tab Heading
        '--edit-assessment-question-tab-heading-color': styles.editAssessment?.questionTab?.headingColor,

        // Edit Assessment - Question Body
        '--edit-assessment-question-body-background-color': styles.editAssessment?.questionBody?.backgroundColor,
        '--edit-assessment-question-body-grid-background-color': styles.editAssessment?.questionBody?.gridBackgroundColor,

        // Edit Assessment - Question Container
        '--edit-assessment-question-container-subgroup-heading-color': styles.editAssessment?.questionContainer?.subgroupHeadingColor,
        '--edit-assessment-question-container-page-caption-background-color': styles.editAssessment?.questionContainer?.pageCaptionBackgroundColor,
        '--edit-assessment-question-container-page-caption-text-color': styles.editAssessment?.questionContainer?.pageCaptionTextColor,

        // Edit Assessment - Navigation Buttons
        '--edit-assessment-pre-next-submit-button-color': styles.editAssessment?.button?.color,
        '--edit-assessment-pre-next-submit-button-background-color': styles.editAssessment?.button?.backgroundColor,
        '--edit-assessment-pre-next-submit-button-hover-background-color': styles.editAssessment?.button?.hoverBackgroundColor,
        '--edit-assessment-pre-next-submit-button-hover-color': styles.editAssessment?.button?.hoverColor,
        '--edit-assessment-pre-next-submit-button-border-color': styles.editAssessment?.button?.borderColor,

        // Edit Assessment - Submit Button
        '--edit-assessment-submit-button-background-color': styles.editAssessment?.submitButton?.backgroundColor,
        '--edit-assessment-submit-button-text-color': styles.editAssessment?.submitButton?.textColor,

        // Edit Assessment - previous Button
        '--edit-assessment-previous-button-background-color': styles.editAssessment?.previousButton?.backgroundColor,
        '--edit-assessment-previous-button-color': styles.editAssessment?.previousButton?.color,

        // Edit Assessment - next Button
        '--edit-assessment-next-button-background-color': styles.editAssessment?.nextButton?.backgroundColor,
        '--edit-assessment-next-button-color': styles.editAssessment?.nextButton?.color,

        // Edit Assessment - Dialog
        '--edit-assessment-dialog-background-color': styles.editAssessment?.dialog?.backgroundColor,
        '--edit-assessment-dialog-overlay-background-color': styles.editAssessment?.dialog?.overlayBackgroundColor,
        '--edit-assessment-dialog-shadow-color': styles.editAssessment?.dialog?.shadowColor,
        '--edit-assessment-dialog-header-text-color': styles.editAssessment?.dialog?.headerTextColor,
        '--edit-assessment-dialog-body-text-color': styles.editAssessment?.dialog?.bodyTextColor,

        // Plans - Tabs
        '--plans-tabs-background-color': styles.plans?.tabs?.backgroundColor,
        '--plans-tabs-color': styles.plans?.tabs?.color,
        '--plans-tabs-active-background-color': styles.plans?.tabs?.activeBackgroundColor,
        '--plans-tabs-active-color': styles.plans?.tabs?.activeColor,
        '--plans-tabs-hover-background-color': styles.plans?.tabs?.hoverBackgroundColor,
        '--plans-tabs-hover-color': styles.plans?.tabs?.hoverColor,
        '--plans-tabs-border-color': styles.plans?.tabs?.borderColor,
        '--plans-tabs-active-border-color': styles.plans?.tabs?.activeBorderColor,
        '--plans-tabs-history-tab-color': styles.plans?.tabs?.historyTabColor,
        '--plans-tabs-packages-tab-color': styles.plans?.tabs?.packagesTabColor,
        '--plans-tabs-icon-active-color': styles.plans?.tabs?.icon?.activeColor,
        '--plans-tabs-icon-inactive-color': styles.plans?.tabs?.icon?.inactiveColor,
        '--plans-tabs-icon-inactive-filter': styles.plans?.tabs?.icon?.inactiveFilter,

        // Biometric Primary Global
        '--biometric-global-background-color': styles.biometric?.global?.backgroundColor,
        '--biometric-global-text-color': styles.biometric?.global?.textColor,

        // Biometric Header Bar
        '--biometric-header-bar-background-color': styles.biometric?.headerBar?.backgroundColor,
        '--biometric-header-bar-text-color': styles.biometric?.headerBar?.textColor,
        '--biometric-header-bar-highlight-text-color': styles.biometric?.headerBar?.highlightTextColor,
        '--biometric-header-bar-link-color': styles.biometric?.headerBar?.linkColor,
        '--biometric-header-bar-link-hover-color': styles.biometric?.headerBar?.linkHoverColor,

        // Biometric Buttons
        '--biometric-button-primary-background-color': styles.biometric?.button?.primaryBackgroundColor,
        '--biometric-button-primary-text-color': styles.biometric?.button?.primaryTextColor,
        '--biometric-button-primary-hover-background-color': styles.biometric?.button?.primaryHoverBackgroundColor,
        '--biometric-button-secondary-background-color': styles.biometric?.button?.secondaryBackgroundColor,
        '--biometric-button-secondary-text-color': styles.biometric?.button?.secondaryTextColor,
        '--biometric-button-secondary-hover-background-color': styles.biometric?.button?.secondaryHoverBackgroundColor,

        // Left sidebar
        '--biometric-left-sidebar-nth-child-background-color': styles.biometric?.leftSideBar?.exerciseContentNthChild,

        // Sidebar
        '--biometric-sidebar-background-color': styles.biometric?.sidebar?.backgroundColor,
        '--biometric-sidebar-header-color': styles.biometric?.sidebar?.headerColor,
        '--biometric-sidebar-text-color': styles.biometric?.sidebar?.textColor,
        '--biometric-sidebar-border-color': styles.biometric?.sidebar?.borderColor,
        '--biometric-sidebar-searchbar-background-color': styles.biometric?.sidebar?.searchBarBackgroundColor,
        '--biometric-sidebar-active-background-color': styles.biometric?.sidebar?.activeBackgroundColor,
        '--biometric-sidebar-active-text-color': styles.biometric?.sidebar?.activeTextColor,

        // Movement Guideline
        '--biometric-movement-guideline-background-color': styles.biometric?.movementGuideline?.backgroundColor,
        '--biometric-movement-guideline-border-color': styles.biometric?.movementGuideline?.borderColor,
        '--biometric-movement-guideline-text-color': styles.biometric?.movementGuideline?.textColor,
        '--biometric-movement-guideline-instruction-text-color': styles.biometric?.movementGuideline?.instructionTextColor,

        //     Chatbot
        '--chatbot-input-focus-outline-color': styles.chatBot?.input?.focusOutlineColor,
        '--chatbot-input-focus-border-color': styles.chatBot?.input?.focusBorderColor,

        '--chatbot-header-background-color': styles.chatBot?.chatBotHeaderBackgroundColor,
        '--chatbot-header-color': styles.chatBot?.chatBotHeaderColor,

        '--chatbot-mic-background-color': styles.chatBot?.chatBotMicBackgroundColor,
        // Chatbot
        '--chat-bot-primary-color': styles.chatBot?.primaryColor,
        '--chat-bot-title-color': styles.chatBot?.titleColor,

        '--chat-bot-primary-color-hover': styles.chatBot?.primaryColorHover,
        '--chat-bot-primary-background-color': styles.chatBot?.primaryBackgroundColor,
        '--chat-bot-primary-background-color-hover': styles.chatBot?.primaryBackgroundColorHover,

        '--chat-bot-body-test-background-color': styles.chatBot?.bodyTestBackgroundColor,
        '--chat-bot-body-test-text-color': styles.chatBot?.bodyTestTextColor,

        '--chat-bot-prev-background-color': styles.chatBot?.prevBackgroundColor,
        '--chat-bot-prev-btn-background-color': styles.chatBot?.prevBtnBackgroundColor,
        '--chat-bot-edit-btn-background-color': styles.chatBot?.editBtnBackgroundColor,

        '--chat-bot-success-background-color': styles.chatBot?.successBackgroundColor,
        '--chat-bot-success-background-color-hover': styles.chatBot?.successBackgroundColorHover,
        '--chat-bot-success-color': styles.chatBot?.successColor,
        '--chat-bot-success-color-hover': styles.chatBot?.successColorHover,

        '--chat-bot-primary-light-color': styles.chatBot?.primaryLightColor,
        '--chat-bot-primary-light-color-hover': styles.chatBot?.primaryLightColorHover,
        '--chat-bot-primary-light-background-color': styles.chatBot?.primaryLightBackgroundColor,
        '--chat-bot-primary-light-background-color-hover': styles.chatBot?.primaryLightBackgroundColorHover,

        '--chat-bot-outline-button-selected-color': styles.chatBot?.selectedOutlinedButton?.color,
        '--chat-bot-outline-button-selected-background-color': styles.chatBot?.selectedOutlinedButton?.backgroundColor,

        '--chat-bot-primary-disabled-color': styles.chatBot?.primaryDisabledColor,
        '--chat-bot-primary-disabled-color-hover': styles.chatBot?.primaryDisabledColorHover,
        '--chat-bot-primary-disabled-background-color': styles.chatBot?.primaryDisabledBackgroundColor,
        '--chat-bot-primary-disabled-background-color-hover': styles.chatBot?.primaryDisabledBackgroundColorHover,

        // Intake from
        '--intake-form-title-color': styles.intakeForm?.titleColor,
        '--intake-form-text-color': styles.intakeForm?.textColor,
        '--intake-form-label-color': styles.intakeForm?.labelColor,
        '--intake-form-input-text-color': styles.intakeForm?.inputTextColor,
        '--intake-form-input-background-color': styles.intakeForm?.inputBackgroundColor,
        '--intake-form-input-border-color': styles.intakeForm?.inputBorderColor,
        // Alert Modal
        '--alert-modal-overlay-background-color': styles.alertModal?.overlayBackgroundColor,
        '--alert-modal-container-background-color': styles.alertModal?.containerBackgroundColor,
        '--alert-modal-container-border-radius': styles.alertModal?.containerBorderRadius,
        '--alert-modal-container-box-shadow': styles.alertModal?.containerBoxShadow,

        // Alert Modal Close Button
        '--alert-modal-close-color': styles.alertModal?.closeColor,
        '--alert-modal-close-hover-color': styles.alertModal?.closeHoverColor,
        '--alert-modal-close-focus-outline-color': styles.alertModal?.closeFocusOutlineColor,

        // Alert Modal Icon
        '--alert-modal-icon-background-color': styles.alertModal?.iconBackgroundColor,
        '--alert-modal-icon-color': styles.alertModal?.iconColor,

        // Alert Modal Title
        '--alert-modal-title-color': styles.alertModal?.titleColor,
        '--alert-modal-title-font-size': styles.alertModal?.titleFontSize,

        // Alert Modal Description
        '--alert-modal-description-color': styles.alertModal?.descriptionColor,
        '--alert-modal-description-background-color': styles.alertModal?.descriptionBackgroundColor,
        '--alert-modal-description-font-size': styles.alertModal?.descriptionFontSize,

        // Alert Modal Button Styles
        '--alert-modal-button-primary-background-color': styles.alertModal?.buttonPrimaryBackgroundColor,
        '--alert-modal-button-primary-color': styles.alertModal?.buttonPrimaryColor,
        '--alert-modal-button-primary-hover-background-color': styles.alertModal?.buttonPrimaryHoverBackgroundColor,

        '--alert-modal-button-secondary-background-color': styles.alertModal?.buttonSecondaryBackgroundColor,
        '--alert-modal-button-secondary-color': styles.alertModal?.buttonSecondaryColor,
        '--alert-modal-button-secondary-hover-background-color': styles.alertModal?.buttonSecondaryHoverBackgroundColor,

        '--alert-modal-button-outline-color': styles.alertModal?.buttonOutlineColor,
        '--alert-modal-button-outline-border-color': styles.alertModal?.buttonOutlineBorderColor,
        '--alert-modal-button-outline-hover-background-color': styles.alertModal?.buttonOutlineHoverBackgroundColor,

        '--alert-modal-button-ghost-color': styles.alertModal?.buttonGhostColor,
        '--alert-modal-button-ghost-hover-background-color': styles.alertModal?.buttonGhostHoverBackgroundColor,
        '--alert-modal-button-ghost-focus-outline-color': styles.alertModal?.buttonGhostFocusOutlineColor,

        // Caution Modal
        '--caution-modal-ques-color': styles.cautionModal?.quesColor,
    };

    Object.entries(styleMap).forEach(([variable, value]) => {
        if (value) root.style.setProperty(variable, value);
    });
}

/**
 * Fetch theme from API and apply it
 */
export async function loadTheme(TENANT_THEME) {
    try {
        if (TENANT_THEME) {
            const { colors, typography, components } = TENANT_THEME;

            console.log('[Theme] API theme loaded successfully');

            // Apply colors from API (with fallback to defaults)
            applyColors({ ...DEFAULT_COLORS, ...colors });

            // Apply typography from API (with fallback to defaults)
            const mergedTypography = {
                fontFamily: { ...DEFAULT_TYPOGRAPHY.fontFamily, ...typography?.fontFamily },
                fontSizes: { ...DEFAULT_TYPOGRAPHY.fontSizes, ...typography?.fontSizes },
                fontWeights: { ...DEFAULT_TYPOGRAPHY.fontWeights, ...typography?.fontWeights }
            };
            applyTypography(mergedTypography);

            // Apply components from API (with fallback to defaults)
            applyComponentsStyle({ ...DEFAULT_COMPONENTS_STYLE, ...components });

        } else {
            console.warn('[Theme] No theme in API response, using defaults');
            applyColors(DEFAULT_COLORS);
            applyTypography(DEFAULT_TYPOGRAPHY);
            applyComponentsStyle(DEFAULT_COMPONENTS_STYLE);
        }

    } catch (error) {
        console.error('[Theme] Error fetching theme:', error.message);
        console.log('[Theme] Using default theme');

        // Apply defaults on error
        applyColors(DEFAULT_COLORS);
        applyTypography(DEFAULT_TYPOGRAPHY);
        applyComponentsStyle(DEFAULT_COMPONENTS_STYLE);
    }
}

export default loadTheme;
